import { EIPRToothMap, IIPRLogItem } from "@/shared/types"
import CheckIcon from "@mui/icons-material/Check"
import { Input } from "@mui/material"
import classNames from "classnames"
import { FC } from "react"
import { IUpdateToothDataParams } from "."

import "./scss/StageItemValue.scss"
interface IProps {
  dataType:
    | "iprURToothDataMemo"
    | "iprULToothDataMemo"
    | "iprLRToothDataMemo"
    | "iprLLToothDataMemo"
  id: EIPRToothMap
  item: IIPRLogItem
  itemIndex: number
  updateToothData: (data: IUpdateToothDataParams) => void
  isPDF: boolean
  switchViewEdit: boolean
}
const StageItemValue: FC<IProps> = ({
  dataType,
  id,
  item,
  itemIndex,
  updateToothData,
  isPDF = false,
  switchViewEdit,
}) => {
  const max = 2
  const min = 0

  const handleChange = (value: string) => {
    if (!switchViewEdit) return
    const newValue = value ? (Number.parseFloat(value) > 0 ? value : "") : ""
    if (!newValue) return
    if (item.isActive) {
      if (Number(item.actualIPRValue) >= Number(item.value)) return
    }
    updateToothData({
      dataType,
      id,
      itemIndex,
      value: {
        isActive: item.isActive ? 0 : 1,
        actualIPRValue: item.actualIPRValue
          ? item.actualIPRValue
          : Number(newValue).toFixed(1).toString(),
      },
    })
  }

  return (
    <div
      className={classNames("stage-item-value", {
        "stage-item-value-reverse":
          dataType === "iprLRToothDataMemo" ||
          dataType === "iprLLToothDataMemo",
      })}
    >
      <div
        className={classNames("ux-value ", {
          "ux-value-disabled":
            !item.value || Number.parseFloat(item.value) === 0,
          "ux-value-active": item.isActive,
        })}
      >
        {/* <Checkbox className="item-checkbox" checked={!!item.isActive} /> */}
        {switchViewEdit && (
          <div
            className="checkbox-icon "
            onClick={() => handleChange(item.value)}
          >
            {item.isActive ? (
              <div className="plan-check-box-outline plan-check-box d-flex ">
                <CheckIcon sx={{ fontSize: "16px", color: "#4d4d4d" }} />
              </div>
            ) : (
              <div className="plan-check-box-outline " />
            )}
          </div>
        )}

        {item.value
          ? Number.parseFloat(item.value) === 0
            ? "-"
            : Number(item.value).toFixed(1)
          : "-"}
      </div>
      <div className="current-input-wrap">
        {isPDF ? (
          <div className="MuiInput-input w-100">{item.actualIPRValue}</div>
        ) : (
          <Input
            value={item.actualIPRValue}
            type="number"
            disabled={!switchViewEdit}
            disableUnderline={true}
            onChange={(e: any) => {
              let value = e.target.value
              if (value > max) {
                value = max
              } else if (value < min) {
                value = min
              }
              if (value.includes(".")) {
                const splitValue = value.split(".")
                if (splitValue.length > 1 && splitValue[1].length > 1) {
                  return
                }
                if (splitValue.length > 1 && !splitValue[0]) {
                  value = "0." + splitValue[1]
                }
              }

              updateToothData({
                dataType,
                id,
                itemIndex,
                value: {
                  isActive: Number(value) >= Number(item.value) ? 1 : 0,
                  actualIPRValue: value,
                },
              })
            }}
          />
        )}
      </div>
    </div>
  )
}

export default StageItemValue
